<form *ngIf="offer$ | async as OfferDetails; else loading" [formGroup]="formGroup" novalidate>
    <mat-card appearance="outlined">
        <mat-card-content fxLayout="column">
            <div formGroupName="Detail" class="offer-details-form">
                <mat-accordion class="OfferDetails" multi>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Offer Details</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                            <div fxLayout="column" fxFlex="auto" class="marginTop">
                                <div class="field-with-previous-step-hint" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline" class="custom-field"
                                    [class.field--modified]="isPropertyModified('Name')">
                                    <mat-label>Offer Name</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="text" formControlName="Name" />
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.Name.hasError('required')">
                                        Offer Name is required
                                    </mat-error>
                                    <mat-error *ngIf="formGroup.controls.Detail.controls.Name.status=='INVALID'">
                                        {{formGroup.controls.Detail.controls.Name.errors!['maxlength'] && 'Maximum
                                        length can be' +
                                        formGroup.controls.Detail.controls.Name.errors!['maxlength']['requiredLength'] +
                                        '.'}}
                                    </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Name') as text">{{ text }}</div>
                                </div>

                                <div fxLayout="row" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">
                                    <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                        [class.field--modified]="isPropertyModified('StartDate')">
                                        <mat-label>Start Date</mat-label>
                                        <input matInput [matDatepicker]="startDatePicker" formControlName="StartDate"
                                            [disabled]="!canEdit()" (dateChange)="onDateCommitted()">
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.StartDate.hasError('required')">
                                            Start date is required.
                                        </mat-error>
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.StartDate.status=='INVALID'">
                                            {{formGroup.controls.Detail.controls.StartDate.errors!['matDatepickerMax']
                                            && 'Start Date exceeded maximum year.'}}
                                        </mat-error>
                                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"
                                            [disabled]="!canEdit()">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #startDatePicker [disabled]="!canEdit()"></mat-datepicker>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('StartDate') as text">{{ text }}</div>
                                </div>

                                    <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                        [class.field--modified]="isPropertyModified('EndDate')">
                                        <mat-label>End Date</mat-label>
                                        <input [disabled]="!canEdit()" matInput [matDatepicker]="endDatePicker"
                                            formControlName="EndDate" (dateChange)="onDateCommitted()">
                                        <mat-error
                                            *ngIf="formGroup.controls.Detail.controls.EndDate.hasError('required')">
                                            End date is required.
                                        </mat-error>
                                        <mat-error *ngIf="formGroup.controls.Detail.controls.EndDate.status=='INVALID'">
                                            {{formGroup.controls.Detail.controls.EndDate.errors!['matDatepickerMax'] &&
                                            'End Date exceeded maximum year.'}}
                                        </mat-error>
                                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"
                                            [disabled]="!canEdit()"></mat-datepicker-toggle>
                                        <mat-datepicker #endDatePicker [disabled]="!canEdit()"></mat-datepicker>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('EndDate') as text">{{ text }}</div>
                                </div>
                                </div>
                                <div class="ia-copy-fields-wrapper"
                                    [class.ia-copy-accepted-panel]="iaCopyAccepted"
                                    [class.ia-copy-review-panel]="showIACopyReview && iaCopyResponses.length && !iaCopyAccepted"
                                    [class.ia-copy-error-flash]="iaCopyErrorFlash">
                                    <div class="field-with-previous-step-hint" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline" fxLayout="row"
                                        [class.field--modified]="isPropertyModified('Headline')"
                                        [class.ia-copy-input]="(showIACopyReview && iaCopyResponses.length) || iaCopyAccepted">
                                        <mat-label>Headline</mat-label>
                                        <textarea [readonly]="!canEdit() || isIACopyPanelActive" matInput type="text"
                                            formControlName="Headline"></textarea>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Headline') as text">{{ text }}</div>
                                </div>

                                    <div class="field-with-previous-step-hint" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline" fxLayout="row"
                                        class="ia-copy-body-field"
                                        [class.field--modified]="isPropertyModified('BodyCopy')"
                                        [class.ia-copy-input]="(showIACopyReview && iaCopyResponses.length) || iaCopyAccepted">
                                        <mat-label>Body Copy</mat-label>
                                        <textarea [readonly]="!canEdit() || isIACopyPanelActive" matInput type="text"
                                            formControlName="BodyCopy"></textarea>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('BodyCopy') as text">{{ text }}</div>
                                </div>

                                    <div class="ia-copy-status-banner ia-copy-review-status"
                                        *ngIf="showIACopyReview && iaCopyResponses.length && !iaCopyAccepted && !isPollingIACopy">
                                        <mat-icon class="ia-copy-status-icon">warning</mat-icon>
                                        <span>Please review Headline and BodyCopy</span>
                                    </div>

                                    <div class="ia-copy-status-banner ia-copy-accepted-status"
                                        *ngIf="iaCopyAccepted">
                                        <mat-icon class="ia-copy-status-icon">check_circle</mat-icon>
                                        <span>Headline and BodyCopy approved</span>
                                    </div>

                                    <div class="ia-copy-inline-error" *ngIf="iaCopyInlineError">
                                        {{ iaCopyInlineError }}
                                    </div>

                                    <ng-container *ngIf="(showIACopyReview || isPollingIACopy) && iaCopyResponses.length && !iaCopyAccepted">
                                        <div class="ia-copy-compare" *ngIf="showComparePanel">
                                            <div class="ia-copy-option" *ngFor="let r of iaCopyResponses; let i = index; trackBy: trackIACopyResponse"
                                                [class.selected]="!isIACopyResponseFailed(r) && !isIACopyResponsePending(r) && selectedResponseIndex === i"
                                                [class.failed]="isIACopyResponseFailed(r)"
                                                [class.pending]="isIACopyResponsePending(r)"
                                                [class.not-selectable]="isIACopyResponseFailed(r) || isIACopyResponsePending(r) || isPollingIACopy || iaCopyFeedbackSubmitting"
                                                (click)="selectIACopyOption(i)">
                                                <div class="ia-copy-option-header">
                                                    <span>Option {{ optionLabel(i) }}</span>
                                                    <mat-radio-button *ngIf="!isIACopyResponseFailed(r) && !isIACopyResponsePending(r)"
                                                        [checked]="selectedResponseIndex === i"
                                                        [disabled]="isPollingIACopy || iaCopyFeedbackSubmitting"
                                                        (click)="$event.stopPropagation(); selectIACopyOption(i)"></mat-radio-button>
                                                </div>
                                                <div class="ia-copy-option-body">
                                                    <ng-container *ngIf="isIACopyResponsePending(r); else iaCopyResolvedContent">
                                                        <div class="ia-copy-option-skeleton">
                                                            <div class="ia-copy-skeleton-line ia-copy-skeleton-line--label"></div>
                                                            <div class="ia-copy-skeleton-line ia-copy-skeleton-line--short"></div>
                                                            <div class="ia-copy-skeleton-line ia-copy-skeleton-line--label"></div>
                                                            <div class="ia-copy-skeleton-line"></div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #iaCopyResolvedContent>
                                                    <ng-container *ngIf="isIACopyResponseFailed(r); else iaCopyOptionContent">
                                                        <p class="ia-copy-failed-message">Copy generation failed for this option. Please select another option. <span *ngIf="r.Error?.trim()" class="ia-copy-failed-error">{{ r.Error }}</span></p>
                                                    </ng-container>
                                                    <ng-template #iaCopyOptionContent>
                                                        <label>HEADLINE</label>
                                                        <p>{{ getIACopyDisplayHeadline(r) }}</p>
                                                        <label>BODY COPY</label>
                                                        <p>{{ getIACopyDisplayBodyCopy(r) }}</p>
                                                    </ng-template>
                                                    <div class="ia-copy-option-regenerate">
                                                        <button mat-icon-button type="button"
                                                            matTooltip="Regenerate"
                                                            [disabled]="iaCopyFeedbackSubmitting || isPollingIACopy || iaCopyAccepted"
                                                            (click)="$event.stopPropagation(); onIACopyRegenerate(r)">
                                                            <mat-icon>autorenew</mat-icon>
                                                        </button>
                                                    </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ia-copy-actions" *ngIf="showIACopyReviewActions">
                                            <div class="ia-copy-actions-left">
                                                <button mat-stroked-button type="button"
                                                    *ngIf="iaCopyResponses.length === 1"
                                                    [disabled]="iaCopyFeedbackSubmitting || isPollingIACopy || iaCopyAccepted"
                                                    (click)="onIACopyRegenerate()">
                                                    <mat-icon class="ia-copy-regen-icon">autorenew</mat-icon>
                                                    Regenerate
                                                </button>
                                                <button mat-stroked-button type="button" *ngIf="iaCopyResponses.length > 1"
                                                    (click)="toggleComparePanel()">
                                                    {{ showComparePanel ? 'Hide comparison' : 'Compare all options' }}
                                                    <mat-icon>{{ showComparePanel ? 'expand_less' : 'expand_more' }}</mat-icon>
                                                </button>
                                                <button mat-stroked-button type="button"
                                                    *ngIf="iaCopyResponses.length > 1"
                                                    [disabled]="iaCopyFeedbackSubmitting || isPollingIACopy || iaCopyAccepted"
                                                    (click)="onIACopyRegenerateAll()">
                                                    <mat-icon class="ia-copy-regen-icon">autorenew</mat-icon>
                                                    Regenerate all
                                                </button>
                                            </div>
                                            <div class="ia-copy-feedback">
                                                <button mat-icon-button type="button" (click)="onIACopyThumbsUp()"
                                                    [disabled]="iaCopyFeedbackSubmitting || iaCopyAccepted"
                                                    [class.active-up]="iaCopyFeedback === 'up'">
                                                    <mat-icon>{{ iaCopyFeedback === 'up' ? 'thumb_up' : 'thumb_up_off' }}</mat-icon>
                                                </button>
                                                <button mat-icon-button type="button" (click)="onIACopyThumbsDown()"
                                                    [disabled]="iaCopyFeedbackSubmitting || iaCopyAccepted"
                                                    [class.active-down]="iaCopyFeedback === 'down'">
                                                    <mat-icon>{{ iaCopyFeedback === 'down' ? 'thumb_down' : 'thumb_down_off' }}</mat-icon>
                                                </button>
                                                <button mat-stroked-button type="button"
                                                    [disabled]="iaCopyFeedbackSubmitting || isPollingIACopy || iaCopyAccepted"
                                                    (click)="onIACopyEdit()">Edit</button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="field-with-previous-step-hint" fxFlex="50" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                    [class.field--modified]="isPropertyModified('Disclaimer')">
                                    <mat-label>Disclaimer</mat-label>
                                    <textarea [readonly]="!canEdit()" matInput type="text"
                                        formControlName="Disclaimer"></textarea>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Disclaimer') as text">{{ text }}</div>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('ClientComment')">
                                <mat-label>Comment</mat-label>
                                <textarea [readonly]="!canEdit()" matInput type="text"
                                    formControlName="ClientComment"></textarea>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('ClientComment') as text">{{ text }}</div>
                                </div>

                            <div fxFlex="33" [class.field--modified]="isPropertyModified('OfferTagIds', 'Tags')">
                                <app-pr1-offer-tags [placeholder]="'Associate Tag...'" [label]="'Offer Tags'"
                                    [context]="'Offer'" [contextId]="offerId" [selectedTagIds]="offerTagIds"
                                    [canEditTags]="canEdit()" (tagRemoved)="removeTag($event)"
                                    (tagAdded)="addTag($event)" [offerTagsFormControl]="tagCtrl"
                                    (tagSelectedEmitter)="tagSelected($event)">
                                </app-pr1-offer-tags>
                                <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('OfferTagIds', 'Tags') as text">{{ text }}</div>
                            </div>

                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('ProductCategoryIds', 'Categories')">
                                <mat-label class="pl-2">Categories</mat-label>
                                <mat-select formControlName="ProductCategoryIds" multiple #select1
                                    (closed)="clearSearch()">
                                    <mat-select-trigger>
                                        <mat-chip-set>
                                            <mat-chip
                                                *ngFor="let category of formGroup.controls.Detail.controls.ProductCategoryIds.value"
                                                [removable]="true" (removed)="onCategoryRemoved(category)">
                                                {{ category?.ProductCategoryName }}
                                                <mat-icon matChipRemove>cancel</mat-icon>
                                            </mat-chip>
                                        </mat-chip-set>
                                    </mat-select-trigger>
                                    <div fxLayout="row">
                                        <div class="search-input-group">
                                            <mat-icon matPrefix>search</mat-icon>
                                            <input placeholder="Search Categories" matInput [formControl]="categoryCtrl"
                                                class="mat-select-search-input" #searchSelectInput />
                                            <button mat-icon-button aria-label="Clear" class="mat-select-search-clear"
                                                (click)="clearData()">
                                                <mat-icon *ngIf="searchSelectInput.value">close</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <mat-option *ngFor="let category of filteredCategory | async" [value]="category"
                                        (click)="updateSelectedItems(select1, category)">
                                        {{category?.ProductCategoryName}}
                                    </mat-option>
                                </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('ProductCategoryIds', 'Categories') as text">{{ text }}</div>
                                </div>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column">

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('TargetURL')">
                                <mat-label>Target Url</mat-label>
                                <input [readonly]="!canEdit()" matInput type="text" formControlName="TargetURL" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.TargetURL.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.TargetURL.errors!['maxlength'] && 'Maximum
                                    length can be
                                    '+formGroup.controls.Detail.controls.TargetURL.errors!['maxlength']['requiredLength']+'.
                                    '}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('TargetURL') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline" *ngIf="offerId != '0'">
                                <mat-label>Id</mat-label>
                                <input [readonly]="!canEdit()" matInput formControlName="Id" readonly>
                            </mat-form-field>

                            <mat-form-field appearance="outline" fxFlex
                                [class.field--modified]="isPropertyModified('ClientKey')">
                                <mat-label>Client Key</mat-label>
                                <input [readonly]="!canEdit()" matInput type="text" formControlName="ClientKey" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.hasError('required')">
                                    Client key is required
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.ClientKey.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.ClientKey.errors!['maxlength'] && 'Maximum
                                    length can be ' +
                                    formGroup.controls.Detail.controls.ClientKey.errors!['maxlength']['requiredLength']
                                    + '.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('ClientKey') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('Rank')">
                                <mat-label>Rank</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="Rank" (input)="onRankInput($event)" (blur)="onRankCommitted()" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.Rank.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.Rank.errors!['max'] && 'Maximum number can be '
                                    + formGroup.controls.Detail.controls.Rank.errors!['max']['max'] + '. '}}
                                    {{formGroup.controls.Detail.controls.Rank.errors!['min'] && 'Minimum required number
                                    can be' + formGroup.controls.Detail.controls.Rank.errors!['min']['min'] + '. '}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Rank') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('BadgeAssetId', 'Badge')">
                                <mat-label>Badge</mat-label>
                                <mat-select [disabled]="!canEdit()" formControlName="BadgeAssetId">
                                    <mat-option *ngFor="let item of assetsforBadge" [value]="item?.Id"
                                        class="badge-dropdown">
                                        <!-- <img *ngIf="item?.FileName" class="badge-option-image" src="{{assetsUrl$ | async}}/{{item?.FileName}}" /> -->
                                        <img *ngIf="item?.WebUrl" class="badge-option-image" [src]="item?.WebUrl"
                                            alt="Offer image">
                                        <img mat-card-md-image *ngIf="!item?.WebUrl"
                                            src="./assets/images/default-image.png" alt="Offer image">
                                        <span>{{item?.AssetName}}</span>
                                    </mat-option>
                                    <mat-option [value]="noneValue">None</mat-option>
                                </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('BadgeAssetId', 'Badge') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('OfferTypeId', 'OfferTypeName')">
                                <mat-label>Offer Type</mat-label>
                                <mat-select [disabled]="!canEdit()" formControlName="OfferTypeId"
                                    (selectionChange)="onOfferTypeSelectionChange($event)"
                                    (closed)="onOfferTypePanelClosed()">
                                    <mat-option *ngFor="let item of offertypes" [value]="item?.Id"
                                        class="badge-dropdown">
                                        <!-- <img *ngIf="item?.Detail?.FileName" class="badge-option-image"
                                            src="{{assetsUrl$ | async}}/{{item?.Detail?.FileName}}" /> -->
                                        {{item?.OfferTypeName}}
                                    </mat-option>
                                    <mat-option [value]="noneValue">None</mat-option>
                                </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('OfferTypeId', 'OfferTypeName') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('LoyaltyIndicator')">
                                <mat-label>Loyalty Indicator</mat-label>
                                <input [readonly]="!canEdit()" matInput type="text" formControlName="LoyaltyIndicator" />
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('LoyaltyIndicator') as text">{{ text }}</div>
                                </div>


                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Print-Related Details</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">

                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('PrintPageId', 'PageNumber')">
                                <mat-label>Page Number</mat-label>
                                <mat-select [disabled]="!canEdit()" formControlName="PrintPageId">
                                    <mat-option *ngFor="let item of printPagesList" [value]="item?.Id"
                                        class="badge-dropdown">
                                        <span>{{item?.PageFrom}}</span>
                                    </mat-option>
                                </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('PrintPageId', 'PageNumber') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('Position')">
                                <mat-label>Position</mat-label>
                                <input [readonly]="!canEdit() || !formGroup['controls'].Detail['controls']['PrintPageId'].value" matInput type="number" formControlName="Position" />
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Position') as text">{{ text }}</div>
                                </div>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Pricing</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="column" class="paddingTop">
                            <div fxFlex="100">
                                <app-offer-pricing-form #pricingForm [canEdit]="canEdit()"
                                    [offerTypeId]="getSelectedOfferTypeId()" [offertypes]="offertypes"
                                    [offerDetails]="offerResponse.Detail"
                                    [modifiedPropertyNames]="modifiedPropertyNames"
                                    [modifiedPropertyOldValues]="modifiedPropertyOldValues"
                                    [showChangesHighlight]="showChangesFromPreviousStep"
                                    (formValueChange)="onPricingFormValueChange($event)"
                                    (formValidityChange)="onPricingFormValidityChange($event)">
                                </app-offer-pricing-form>
                            </div>

                            <div fxLayout="row wrap" fxLayoutGap="16px">
                                <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                    [class.field--modified]="isPropertyModified('AndUp')">
                                    <mat-label>And Up</mat-label>
                                    <input [readonly]="!canEdit()" matInput type="text" formControlName="AndUp" />
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AndUp') as text">{{ text }}</div>
                                </div>

                                <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                    [class.field--modified]="isPropertyModified('Language')">
                                    <mat-label>Language</mat-label>
                                    <mat-select [disabled]="!canEdit()" formControlName="Language">
                                    <mat-option *ngFor="let language of languages" [value]="language" class="badge-dropdown">{{language}}</mat-option>
                                        <mat-option [value]="noneValue">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Language') as text">{{ text }}</div>
                                </div>

                                <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                    [class.field--modified]="isPropertyModified('Country')">
                                    <mat-label>Country</mat-label>
                                    <mat-select [disabled]="!canEdit()" formControlName="Country">
                                    <mat-option *ngFor="let country of countries" [value]="country" class="badge-dropdown">{{country}}</mat-option>
                                        <mat-option [value]="noneValue">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Country') as text">{{ text }}</div>
                                </div>

                                <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                    [class.field--modified]="isPropertyModified('Currency')">
                                    <mat-label>Currency</mat-label>
                                    <mat-select [disabled]="!canEdit()" formControlName="Currency">
                                    <mat-option *ngFor="let currency of currencies" [value]="currency" class="badge-dropdown">{{currency}}</mat-option>
                                        <mat-option [value]="noneValue">None</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('Currency') as text">{{ text }}</div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Additional Discounts</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" class="paddingTop">
                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"  [class.has-error]="formGroup.controls.Detail.controls.RewardAmount.invalid && formGroup.controls.Detail.controls.RewardAmount.touched"
                                [class.field--modified]="isPropertyModified('RewardAmount')">
                                <mat-label>Reward Amount</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="RewardAmount"
                                    pattern="\d{1,5}" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardAmount.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardAmount.errors!['max'] && 'Maximum number
                                    can be '+formGroup.controls.Detail.controls.RewardAmount.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.RewardAmount.errors!['min'] && 'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.RewardAmount.errors!['min']['min']+'. '}}
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardAmount.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardAmount.errors!['pattern'] && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('RewardAmount') as text">{{ text }}</div>
                                </div>


                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"  [class.has-error]="formGroup.controls.Detail.controls.RewardQuantity.invalid && formGroup.controls.Detail.controls.RewardQuantity.touched"
                                [class.field--modified]="isPropertyModified('RewardQuantity')">
                                <mat-label>Reward Quantity</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="RewardQuantity"
                                    pattern="\d{1,5}" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardQuantity.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardQuantity.errors!['max'] && 'Maximum
                                    number can be
                                    '+formGroup.controls.Detail.controls.RewardQuantity.errors!['max']['max']+'. '}}
                                    {{formGroup.controls.Detail.controls.RewardQuantity.errors!['min'] && 'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.RewardQuantity.errors!['min']['min']+'. '}}
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardQuantity.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardQuantity.errors!['pattern'] && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('RewardQuantity') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="33" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline" [class.has-error]="formGroup.controls.Detail.controls.RewardSpend.invalid && formGroup.controls.Detail.controls.RewardSpend.touched"
                                [class.field--modified]="isPropertyModified('RewardSpend')">
                                <mat-label>Reward Spend</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number" formControlName="RewardSpend"
                                    pattern="\d{1,5}" />
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardSpend.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardSpend.errors!['max'] && 'Maximum number
                                    can be '+formGroup.controls.Detail.controls.RewardSpend.errors!['max']['max']+'. '}}
                                    {{formGroup.controls.Detail.controls.RewardSpend.errors!['min'] && 'Minimum required
                                    number can be
                                    '+formGroup.controls.Detail.controls.RewardSpend.errors!['min']['min']+'. '}}
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.Detail.controls.RewardSpend.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.RewardSpend.errors!['pattern'] && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('RewardSpend') as text">{{ text }}</div>
                                </div>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" >
                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('AdditionalDiscountAmount')">
                                <mat-label>Additional Discount Amount</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountAmount" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountAmount.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount.errors!['min']['min']+'.
                                    '}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AdditionalDiscountAmount') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('AdditionalDiscountQuantity')">
                                <mat-label>Additional Discount Quantity</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountQuantity" pattern="\d{1,5}" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountQuantity.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['min']['min']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity.errors!['pattern']
                                    && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AdditionalDiscountQuantity') as text">{{ text }}</div>
                                </div>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" >
                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('AdditionalDiscountAmount2')">
                                <mat-label>Additional Discount Amount 2</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountAmount2" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountAmount2.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount2.errors!['min']['min']+'.
                                    '}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AdditionalDiscountAmount2') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('AdditionalDiscountQuantity2')">
                                <mat-label>Additional Discount Quantity 2</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountQuantity2" pattern="\d{1,5}" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['min']['min']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity2.errors!['pattern']
                                    && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AdditionalDiscountQuantity2') as text">{{ text }}</div>
                                </div>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" >
                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('AdditionalDiscountAmount3')">
                                <mat-label>Additional Discount Amount 3</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountAmount3" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountAmount3.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['min']['min']+'.
                                    '}}
                                      {{formGroup.controls.Detail.controls.AdditionalDiscountAmount3.errors!['pattern'] && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AdditionalDiscountAmount3') as text">{{ text }}</div>
                                </div>

                            <div class="field-with-previous-step-hint" fxFlex="auto" fxLayout="column">
                                    <mat-form-field data-hint-wrapped="true" appearance="outline"
                                [class.field--modified]="isPropertyModified('AdditionalDiscountQuantity3')">
                                <mat-label>Additional Discount Quantity 3</mat-label>
                                <input [readonly]="!canEdit()" matInput type="number"
                                    formControlName="AdditionalDiscountQuantity3" pattern="\d{1,5}" />
                                <mat-error
                                    *ngIf="formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.status=='INVALID'">
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['max'] &&
                                    'Maximum
                                    number
                                    can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['max']['max']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['min'] &&
                                    'Minimum
                                    required number can be
                                    '+formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['min']['min']+'.
                                    '}}
                                    {{formGroup.controls.Detail.controls.AdditionalDiscountQuantity3.errors!['pattern']
                                    && 'Decimal
                                    values are not allowed.'}}
                                </mat-error>
                                </mat-form-field>
                                    <div class="previous-step-change-hint" *ngIf="getPreviousStepOldValue('AdditionalDiscountQuantity3') as text">{{ text }}</div>
                                </div>
                        </div>

                    </mat-expansion-panel>

                   
                        <app-dynamic-fields-section
                            *ngIf="(customFields$ | async)?.length"
                            [formGroup]="getCustomFieldsGroup()"
                            [customFields$]="customFields$"
                            [modifiedPropertyNames]="modifiedPropertyNames"
                            [modifiedPropertyOldValues]="modifiedPropertyOldValues"
                            [showChangesHighlight]="showChangesFromPreviousStep">
                        </app-dynamic-fields-section>
                
                </mat-accordion>
            </div>
        </mat-card-content>
        <mat-card-actions class="card-footer-actions" fxLayout="row"
            [fxLayoutAlign]="offerId != '0' && OfferDetails?.Detail?.OfferVariantName == 'Base' ?'space-between':'end'">
            <button appAuthorizeControl="edit||offermang" mat-raised-button type="button" color="warn"
                (click)="deleteBaseRecord()"
                *ngIf="offerId != '0' && OfferDetails?.Detail?.OfferVariantName == 'Base' && readOnlyMode != true">
                Delete
            </button>
            <div fxLayout="row wrap" fxLayoutGap.gt-sm="16px" fxLayout.lt-md="column" fxLayoutAlign="end">
                <button class="btn-right" mat-stroked-button type="button" (click)="cancel()">
                    <span *ngIf="canEdit()">Cancel</span>
                    <span *ngIf="!canEdit()">Close</span>
                </button>
                <button *ngIf="canEdit()" class="btn-right" mat-raised-button type="button" (click)="save()"
                    [disabled]="formGroup.invalid || !isPricingFormValid || isRun || isIACopyProcessing || isIACopyReviewPending" color="accent">
                    Save
                </button>
            </div>
        </mat-card-actions>
    </mat-card>
</form>

<ng-template #loading>
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</ng-template>
